/**
 * Invoice (Rechnung) API Endpoints
 * Centralizes all invoice-related API calls. `id` is the canonical documentId.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { ApiListResponse, ApiResponse, EntityPayload, QueryParams } from "../../types/api";
import type { Rechnung } from "../../types/entities";

export const invoiceApi = {
  getAll: (params: QueryParams = {}): Promise<ApiListResponse<Rechnung>> =>
    api.get("/api/rechnungs", { params }),

  getById: (id: string, params: QueryParams = {}): Promise<ApiResponse<Rechnung>> =>
    api.get(`/api/rechnungs/${id}`, { params }),

  create: (data: EntityPayload): Promise<ApiResponse<Rechnung>> =>
    api.post("/api/rechnungs", { data }),

  update: (id: string, data: EntityPayload): Promise<ApiResponse<Rechnung>> =>
    api.put(`/api/rechnungs/${id}`, { data }),

  delete: (id: string): Promise<AxiosResponse> => api.delete(`/api/rechnungs/${id}`),

  /** Export invoices (accounting CSV; controller reads { from, to } from body.data). */
  export: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/export/rechnung", { data }),
};
